import React, { useEffect, useState } from "react";
import "./FoodSection.css";
import Card from "./Card";
import axios from "axios";

const FoodSection = (props) => {
  const [foodItem, setFoodItem] = useState([]);
  const [foodCategory, setFoodCategory] = useState([]);

  const getData = async () => {
    try {
      const response = await axios.post("https://hungryhub-backend.vercel.app/api/foodData");

      const data = response.data;
      setFoodItem(data[0]);
      setFoodCategory(data[1]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="food-items">
      {foodCategory.length === 0 ? (
        <p>No Such Data</p>
      ) : (
        foodCategory.map((data) => {
          return (
            <div key={data._id}>
              <div key={data._id}>
                <h1>{data.CategoryName}</h1>
              </div>
              <hr />
              <div className="food-item-cards">
                {foodItem.length === 0 ? (
                  <p>No Such Data</p>
                ) : (
                  foodItem
                    .filter(
                      (item) =>
                        item.CategoryName === data.CategoryName &&
                        (props.userSearch.length === 0
                          ? true
                          : item.name
                            .toLowerCase()
                            .includes(props.userSearch.toLowerCase()))
                    )
                    .map((filterItems) => {
                      return (
                        <div key={filterItems._id}>
                          <Card
                            foodItems={filterItems}
                            options={filterItems.options[0]}
                          />
                        </div>
                      );
                    })
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default FoodSection;
